import api from "../utils/api";
import { setAlert } from "./alert";
import {
  CLEAR_ACTIVE_EXERCISE,
  FLIP_EXERCISE_ORIENTATION,
  SELECT_ACTIVE_EXERCISE,
} from "./types";

export function selectActiveExercise(exerciseId) {
  return async (dispatch) => {

    try {
    const token = localStorage.getItem("token");

    const res = await api.get(`user-day-exercise/${exerciseId}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    const exercise = res.data.data;

    dispatch({
      type: SELECT_ACTIVE_EXERCISE,
      payload: exercise,
    });
    } catch (error) {
        const msg = error?.response?.data?.message;
        dispatch(setAlert(msg, "danger"));
    }
  };
}

export function flipExerciseOrientation() {
  return {
    type: FLIP_EXERCISE_ORIENTATION,
  };
}

export function clearActiveExercise() {
  return {
    type: CLEAR_ACTIVE_EXERCISE,
  };
}
